import { forwardRef } from 'react';
import MuiAlert from '@mui/material/Alert';
import {
    CheckCircle as CheckCircleIcon,
    Error as ErrorIcon,
    ErrorOutlineRounded as WarningIcon,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { BRAND_TEAL } from '@constants/colors';

const CssMuiAlert = styled(MuiAlert)({
    '&.MuiAlert-root': {
        padding: '8px 12px',
        borderRadius: 8,
        alignItems: 'center',
    },
    '& .MuiAlert-icon': {
        opacity: 1,
        padding: 0,
    },
    '& .MuiAlert-message': {
        padding: 0,
    },
    '& .MuiAlert-action': {
        paddingTop: 0,
    },
    '&.MuiAlert-filled.MuiAlert-colorSuccess': {
        backgroundColor: '#BDE0CC',
        color: 'var(--primary-main)',
    },
    '&.MuiAlert-filled.MuiAlert-colorInfo': {
        backgroundColor: 'var(--primary-light)',
        color: BRAND_TEAL,
    },
    '& .MuiSvgIcon-root': {
        fontSize: '20px',
    },
    '&.MuiAlert-filled.MuiAlert-colorError': {
        backgroundColor: '#ff99ac',
        color: '#b00020',
    },
    '&.MuiAlert-filled.MuiAlert-colorWarning': {
        backgroundColor: '#FFE0A0',
        color: '#7A5200',
    },
});

const Alert = forwardRef((props, ref) => {
    return (
        <CssMuiAlert
            ref={ref}
            variant="filled"
            iconMapping={{ success: <CheckCircleIcon />, error: <ErrorIcon />, warning: <WarningIcon /> }}
            {...props}
        />
    );
});

Alert.displayName = 'Alert';

export default Alert;
